import axios from 'axios';
import { getUserName, getUserToken } from '../../utils/localStoarege';
import { lockDeviceCenterMachine, machineUrl, masterjiOldLockApiGet, performLockDeviceCenterMachine } from '../../constants/apis/clinic_apis';

export const getMachines = async (query) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(machineUrl, config);
    return response;
};

export const getMachineToggles = async () => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(lockDeviceCenterMachine + getUserName(), config);
    return response;
};

export const getMasterjiOldLocks = async () => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(masterjiOldLockApiGet + getUserName() + "/", config);
    return response;
};

export const postMasterjiOldLocks = async ({ data }) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(masterjiOldLockApiGet + getUserName() + "/", data, config);
    return response;
};

export const toggleMachineToggles = async (id, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(performLockDeviceCenterMachine + id + "/", data, config);
    return response;
};
